import { IConstraintSpudLimitDetail } from '../../interfaces/iconstraint-spud-limit-detail';
import { Area } from '../area';
import { ConstraintSpudLimit } from '../constraint-spud-limit';

export class ConstraintSpudLimitDetailBase {
  ConstraintSpudLimitDetailId: number;
  ConstraintSpudLimitId: number;
  AreaId: number;
  SpudLimit: number | null;
  SpudWindow: number | null;
  EffectiveStartDate: Date | null;
  EffectiveEndDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  ConstraintSpudLimit?: ConstraintSpudLimit;

  constructor(item?: IConstraintSpudLimitDetail) {
    if (item) {

      this.ConstraintSpudLimitDetailId = item.ConstraintSpudLimitDetailId;
      this.ConstraintSpudLimitId = item.ConstraintSpudLimitId;
      this.AreaId = item.AreaId;
      this.SpudLimit = item.SpudLimit;
      this.SpudWindow = item.SpudWindow;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveEndDate = item.EffectiveEndDate ? new Date(item.EffectiveEndDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.ConstraintSpudLimit = new ConstraintSpudLimit(item.ConstraintSpudLimit);
    }
  }
}